import { Box, Text } from "@chakra-ui/layout";

const Archives = () => {
    return (
        <Box ml="160px" mt="5%">
            <Text fontSize="2xl">Archive is not available</Text>
        </Box>
    );
}

export default Archives;